import type { TranslationMessages } from '@app/src/i18n'
import { getMessages, loadMessages } from '@app/src/i18n'
import { useEffect, useState } from 'react'

/**
 * Translations for the given language, loading the file on demand.
 * Only the cached locale and the default language are loaded at startup, so a
 * language change resolves asynchronously. The previously loaded messages are
 * kept until the new ones arrive to avoid rendering untranslated message ids.
 */
const useTranslationMessages = (language: string): TranslationMessages => {
  const [messages, setMessages] = useState<TranslationMessages>(() => getMessages(language))

  useEffect(() => {
    let isCurrentLanguage = true

    loadMessages(language)
      .then(loadedMessages => {
        if (isCurrentLanguage) {
          setMessages(loadedMessages)
        }
      })
      .catch(error => {
        // Keep the messages already on screen rather than dropping to message ids
        console.error(`Could not load translations for ${language}`, error)
      })

    return () => {
      isCurrentLanguage = false
    }
  }, [language])

  return messages
}

export default useTranslationMessages
